module.exports = __webpack_public_path__ + "media/img/frontend_application/laptop-303620215f9edfe7f4c0d889f197fdbc.webp";